import React, { useState, useEffect } from "react";
import "../styles/PrivacyPopup.css";

const PrivacyPopup = () => {
  const [visible, setVisible] = useState(false);
  const [hiding, setHiding]   = useState(false);

  useEffect(() => {
    // Show after 5 seconds only if user hasn't dismissed it before
    const seen = localStorage.getItem("iyconsoft_privacy_popup");
    if (!seen) {
      const t = setTimeout(() => setVisible(true), 5000);
      return () => clearTimeout(t);
    }
  }, []);

  const dismiss = () => {
    setHiding(true);
    localStorage.setItem("iyconsoft_privacy_popup", "dismissed");
    setTimeout(() => setVisible(false), 400);
  };

  if (!visible) return null;

  return (
    <div className={`prv-popup ${hiding ? "prv-popup--hiding" : ""}`}>

      {/* Header */}
      <div className="prv-popup__header">
        <div className="prv-popup__icon">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.2" strokeLinecap="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
          </svg>
        </div>
        <span className="prv-popup__title">Let's Talk</span>
        <button className="prv-popup__close" onClick={dismiss} aria-label="Close">
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18"/>
            <line x1="6" y1="6" x2="18" y2="18"/>
          </svg>
        </button>
      </div>

      {/* Body */}
      <div className="prv-popup__body">
        <p className="prv-popup__text">
          We are <strong>NDPR certified</strong> and committed to safeguarding
          your personal data. You have full rights over how your data is used
          and may exercise those rights at any time.
        </p>
        <a href="/privacy" className="prv-popup__link" onClick={dismiss}>
          See our Privacy Notice
          <svg width="13" height="13" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </a>
      </div>

    </div>
  );
};

export default PrivacyPopup;
